import { addScript } from '@tunein/web-utils';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import pick from 'lodash/pick';
import { v4 as uuidv4 } from 'uuid';
import adSlotManager from '../../../../ads/adSlotManager';
import reporter from '../../../../ads/reporter';
import { COMPANION_AD_CLICKED, COMPANION_AD_RENDER_ERROR, COMPANION_INVALID_CLICK_HANDLER, IMA_PLAYER_AD_COMPANION_ERROR, IMA_PLAYER_AD_ERROR, IMA_PLAYER_AD_REQUEST_REPORTING_ERROR, IMA_PLAYER_AUTOPLAY_ERROR, IMA_PLAYER_ERROR, } from '../../../../logging/constants';
import logger from '../../../../logging/logger';
import { State, addStateChangeListener, getState, removeStateChangeListener, updateState, } from '../../../../utils/applicationState';
import { MediumTypes } from '../../../../utils/constants';
import isDebugEnabled from '../../../../utils/isDebugEnabled';
import { DISCORD_IMA_PLAYER_SCRIPT, IMA_PLAYER_SCRIPT, IMA_PLAYER_SCRIPT_ID, NO_FILL_LABEL, VIDEO_MEDIUM, } from '../../../constants';
import Events from '../../Events';
import CompanionAdManager from '../../companions/CompanionAdManager';
import CompanionCache from '../../companions/CompanionCache';
import companionEvents from '../../companions/companionEvents';
import mediaEvents from '../../mediaEvents';
import ImaPlayer from './ImaPlayer';
import imaEvents from './imaEvents';
const imaPlayerAdapter = {
    adSlot: {},
    imaPlayer: null,
    companionAdManager: null,
    init() {
        logger.debugEnabled = isDebugEnabled();
        this.volume = this._volume.bind(this);
        this.onAdRequested = this._onAdRequested.bind(this);
        this.onAdLoaded = this._onAdLoaded.bind(this);
        this.onAdStarted = this._onAdStarted.bind(this);
        this.onAdSkipped = this._onAdSkipped.bind(this);
        this.onAdImpression = this._onAdImpression.bind(this);
        this.onAdCompleted = this._onAdCompleted.bind(this);
        this.onAllAdsCompleted = this._onAllAdsCompleted.bind(this);
        this.onAdCompanionLoadError = this._onAdCompanionLoadError.bind(this);
        this.onAdError = this._onAdError.bind(this);
        this.onAutoPlayError = this._onAutoPlayError.bind(this);
        this.onVideoAdLoaded = this._onVideoAdLoaded.bind(this);
        this.onVideoAdStarted = this._onVideoAdStarted.bind(this);
        this.onVideoAdSkipped = this._onVideoAdSkipped.bind(this);
        this.onVideoAdImpression = this._onVideoAdImpression.bind(this);
        this.onVideoAdPaused = this._onVideoAdPaused.bind(this);
        this.onVideoAdProgress = this._onVideoAdProgress.bind(this);
        this.onVideoAdResumed = this._onVideoAdResumed.bind(this);
        this.onVideoAdCompleted = this._onVideoAdCompleted.bind(this);
        this.onAudioLoaded = this._onAudioLoaded.bind(this);
        this.onAudioAdStarted = this._onAudioAdStarted.bind(this);
        this.onAudioAdSkipped = this._onAudioAdSkipped.bind(this);
        this.onAudioAdPaused = this._onAudioAdPaused.bind(this);
        this.onAudioAdProgress = this._onAudioAdProgress.bind(this);
        this.onAudioAdResumed = this._onAudioAdResumed.bind(this);
        this.onAudioAdCompleted = this._onAudioAdCompleted.bind(this);
        this.onAudioCompanionsLoaded = this._onAudioCompanionsLoaded.bind(this);
        this.onAudioCompanion = this._onAudioCompanion.bind(this);
        this.onInvalidCompanionClickHandler =
            this._onInvalidCompanionClickHandler.bind(this);
        this.onCompanionAdRenderError = this._onCompanionAdRenderError.bind(this);
        this.onCompanionAdClick = this._onCompanionAdClick.bind(this);
        this.onCompanionSlotRefresh = this._onCompanionSlotRefresh.bind(this);
    },
    registerEventHandlers() {
        this.imaPlayer.on(imaEvents.AdEvent.AD_REQUESTED, this.onAdRequested);
        this.imaPlayer.on(imaEvents.AdEvent.AD_LOADED, this.onAdLoaded);
        this.imaPlayer.on(imaEvents.AdEvent.AD_STARTED, this.onAdStarted);
        this.imaPlayer.on(imaEvents.AdEvent.AD_SKIPPED, this.onAdSkipped);
        this.imaPlayer.on(imaEvents.AdEvent.AD_IMPRESSION, this.onAdImpression);
        this.imaPlayer.on(imaEvents.AdEvent.AD_COMPLETED, this.onAdCompleted);
        this.imaPlayer.on(imaEvents.AdEvent.ALL_ADS_COMPLETED, this.onAllAdsCompleted);
        this.imaPlayer.on(imaEvents.AdEvent.AD_COMPANIONS_LOAD_ERROR, this.onAdCompanionLoadError);
        this.imaPlayer.on(imaEvents.AdEvent.AD_ERROR, this.onAdError);
        this.imaPlayer.on(imaEvents.AdEvent.AUTOPLAY_DISALLOWED_ERROR, this.onAutoPlayError);
        this.imaPlayer.on(imaEvents.VideoEvent.AD_LOADED, this.onVideoAdLoaded);
        this.imaPlayer.on(imaEvents.VideoEvent.AD_STARTED, this.onVideoAdStarted);
        this.imaPlayer.on(imaEvents.VideoEvent.AD_SKIPPED, this.onVideoAdSkipped);
        this.imaPlayer.on(imaEvents.VideoEvent.AD_IMPRESSION, this.onVideoAdImpression);
        this.imaPlayer.on(imaEvents.VideoEvent.AD_PAUSED, this.onVideoAdPaused);
        this.imaPlayer.on(imaEvents.VideoEvent.AD_PROGRESS, this.onVideoAdProgress);
        this.imaPlayer.on(imaEvents.VideoEvent.AD_RESUMED, this.onVideoAdResumed);
        this.imaPlayer.on(imaEvents.VideoEvent.AD_COMPLETED, this.onVideoAdCompleted);
        this.imaPlayer.on(imaEvents.AudioEvent.AD_LOADED, this.onAudioLoaded);
        this.imaPlayer.on(imaEvents.AudioEvent.AD_STARTED, this.onAudioAdStarted);
        this.imaPlayer.on(imaEvents.AudioEvent.AD_SKIPPED, this.onAudioAdSkipped);
        this.imaPlayer.on(imaEvents.AudioEvent.AD_PAUSED, this.onAudioAdPaused);
        this.imaPlayer.on(imaEvents.AudioEvent.AD_PROGRESS, this.onAudioAdProgress);
        this.imaPlayer.on(imaEvents.AudioEvent.AD_RESUMED, this.onAudioAdResumed);
        this.imaPlayer.on(imaEvents.AudioEvent.AD_COMPLETED, this.onAudioAdCompleted);
        this.imaPlayer.on(imaEvents.AudioEvent.AD_COMPANIONS_LOADED, this.onAudioCompanionsLoaded);
        this.companionAdManager.on(companionEvents.loaded, this.onAudioCompanion);
        this.companionAdManager.on(companionEvents.clickError, this.onInvalidCompanionClickHandler);
        this.companionAdManager.on(companionEvents.renderError, this.onCompanionAdRenderError);
        this.companionAdManager.on(companionEvents.clicked, this.onCompanionAdClick);
        this.companionAdManager.on(companionEvents.refreshDisplaySlot, this.onCompanionSlotRefresh);
        logger.debug('Registered All IMA Audio Video Ad Events.');
    },
    removeEventHandlers() {
        this.imaPlayer.off(imaEvents.AdEvent.AD_REQUESTED, this.onAdRequested);
        this.imaPlayer.off(imaEvents.AdEvent.AD_LOADED, this.onAdLoaded);
        this.imaPlayer.off(imaEvents.AdEvent.AD_STARTED, this.onAdStarted);
        this.imaPlayer.off(imaEvents.AdEvent.AD_SKIPPED, this.onAdSkipped);
        this.imaPlayer.off(imaEvents.AdEvent.AD_IMPRESSION, this.onAdImpression);
        this.imaPlayer.off(imaEvents.AdEvent.AD_COMPLETED, this.onAdCompleted);
        this.imaPlayer.off(imaEvents.AdEvent.ALL_ADS_COMPLETED, this.onAllAdsCompleted);
        this.imaPlayer.off(imaEvents.AdEvent.AD_COMPANIONS_LOAD_ERROR, this.onAdCompanionLoadError);
        this.imaPlayer.off(imaEvents.AdEvent.AD_ERROR, this.onAdError);
        this.imaPlayer.off(imaEvents.AdEvent.AUTOPLAY_DISALLOWED_ERROR, this.onAutoPlayError);
        this.imaPlayer.off(imaEvents.VideoEvent.AD_LOADED, this.onVideoAdLoaded);
        this.imaPlayer.off(imaEvents.VideoEvent.AD_STARTED, this.onVideoAdStarted);
        this.imaPlayer.off(imaEvents.VideoEvent.AD_SKIPPED, this.onVideoAdSkipped);
        this.imaPlayer.off(imaEvents.VideoEvent.AD_IMPRESSION, this.onVideoAdImpression);
        this.imaPlayer.off(imaEvents.VideoEvent.AD_PAUSED, this.onVideoAdPaused);
        this.imaPlayer.off(imaEvents.VideoEvent.AD_PROGRESS, this.onVideoAdProgress);
        this.imaPlayer.off(imaEvents.VideoEvent.AD_RESUMED, this.onVideoAdResumed);
        this.imaPlayer.off(imaEvents.VideoEvent.AD_COMPLETED, this.onVideoAdCompleted);
        this.imaPlayer.off(imaEvents.AudioEvent.AD_LOADED, this.onAudioLoaded);
        this.imaPlayer.off(imaEvents.AudioEvent.AD_STARTED, this.onAudioAdStarted);
        this.imaPlayer.off(imaEvents.AudioEvent.AD_SKIPPED, this.onAudioAdSkipped);
        this.imaPlayer.off(imaEvents.AudioEvent.AD_PAUSED, this.onAudioAdPaused);
        this.imaPlayer.off(imaEvents.AudioEvent.AD_PROGRESS, this.onAudioAdProgress);
        this.imaPlayer.off(imaEvents.AudioEvent.AD_RESUMED, this.onAudioAdResumed);
        this.imaPlayer.off(imaEvents.AudioEvent.AD_COMPLETED, this.onAudioAdCompleted);
        this.imaPlayer.off(imaEvents.AudioEvent.AD_COMPANIONS_LOADED, this.onAudioCompanionsLoaded);
        this.companionAdManager.off(companionEvents.loaded, this.onAudioCompanion);
        this.companionAdManager.off(companionEvents.clickError, this.onInvalidCompanionClickHandler);
        this.companionAdManager.off(companionEvents.renderError, this.onCompanionAdRenderError);
        this.companionAdManager.off(companionEvents.clicked, this.onCompanionAdClick);
        this.companionAdManager.off(companionEvents.refreshDisplaySlot, this.onCompanionSlotRefresh);
        logger.debug('Removed All IMA Audio/Video Ad Events.');
    },
    resetAdSlots() {
        const companions = adSlotManager.getCompanionSlots();
        if (companions.length) {
            forEach(companions, (slot) => slot.refresh());
            adSlotManager.resetCompanionSlots();
        }
        else {
            forEach(adSlotManager.getDisplaySlots(), (slot) => slot.refresh());
        }
    },
    addPlayerScript() {
        if (global.google?.ima) {
            return;
        }
        const isInDiscordIFrame = getState(State.isInDiscordIFrame);
        return new Promise((res, rej) => {
            try {
                addScript({
                    src: isInDiscordIFrame
                        ? DISCORD_IMA_PLAYER_SCRIPT
                        : IMA_PLAYER_SCRIPT,
                    id: IMA_PLAYER_SCRIPT_ID,
                    async: true,
                }).then(res);
            }
            catch (e) {
                rej(e);
            }
        });
    },
    async initialize() {
        try {
            this.companionAdManager = new CompanionAdManager(new CompanionCache());
            this.imaPlayer = new ImaPlayer(global.google);
            this.imaPlayer.initialize(getState(State.videoAdContainerId), {
                volume: getState(State.volume),
                isMobile: getState(State.isMobile),
                blankMp3Url: getState(State.blankMp3Url),
            });
            addStateChangeListener('volume', this.volume);
            await this.addPlayerScript();
            logger.debug('Created New IMA Player.');
        }
        catch (ex) {
            logger.debug('Error during IMA initialization.', ex);
            logger.error({
                message: IMA_PLAYER_ERROR,
                error: ex,
            });
        }
    },
    isInitialized() {
        return !!this.imaPlayer;
    },
    deregisterSlot(slot) {
        if (!(slot && this.adSlot)) {
            return;
        }
        const slotName = this.adSlot.name;
        if (slot.name !== slotName || slot.elementId !== slotName) {
            return;
        }
        removeStateChangeListener('volume', this.volume);
        this.imaPlayer.destroy();
        this.removeEventHandlers();
        logger.debug('Destroyed IMA Player. (deregisterSlot)');
    },
    async serveAd(params) {
        const { slot, urlTag } = params;
        let isAdFinishedPlaying = true;
        try {
            await this.managePlayBack(slot, urlTag);
        }
        catch (ex) {
            logger.error({
                message: IMA_PLAYER_ERROR,
                error: ex,
                data: reporter.getParameters(this.adSlot),
            });
            if (ex.adInfo?.isVideoAd &&
                ex.errorType === Events.ErrorTypes.AD_PLAY_START_TIMEOUT) {
                slot?.setNextSlot();
                isAdFinishedPlaying = false;
                logger.debug('The IMA Video Ad did not start playing within timeout.');
            }
        }
        this.isPlayingVideo = false;
        this.adSlot = {};
        this.resetAdSlots();
        this.removeEventHandlers();
        this.imaPlayer.unload();
        if (isAdFinishedPlaying) {
            logger.debug('Finished Playing IMA Audio/Video Ad.');
        }
    },
    async managePlayBack(slot, url) {
        if (!(slot && url)) {
            throw new Error('No slot or urlTag provided to serveAd');
        }
        this.adSlot = slot;
        this.adSlot.medium = MediumTypes.audio;
        this.adSlot.requestId = uuidv4();
        this.isPlayingVideo = false;
        this.registerEventHandlers();
        return await this.playAd(url);
    },
    playAd(url) {
        return new Promise(async (resolve, reject) => {
            try {
                this.imaPlayer.once(imaEvents.AdEvent.AD_ERROR, reject);
                this.imaPlayer.once(imaEvents.AdEvent.AUTOPLAY_DISALLOWED_ERROR, reject);
                this.imaPlayer.once(imaEvents.AdEvent.ALL_ADS_COMPLETED, resolve);
                await this.imaPlayer.start(url);
            }
            catch (ex) {
                reject(ex);
            }
        });
    },
    async preload() {
        if (!this.isInitialized()) {
            await this.initialize();
        }
        this.imaPlayer.preload();
    },
    play() {
        this.imaPlayer.resume();
    },
    pause() {
        this.imaPlayer.pause();
    },
    stop() {
        if (this.imaPlayer) {
            this.imaPlayer.stop();
        }
    },
    resize(width, height) {
        if (this.isPlayingVideo) {
            this.imaPlayer.resize(width, height);
        }
    },
    _volume(volume) {
        this.imaPlayer.volume(volume);
    },
    _onAdRequested() {
        const { Type, Status } = Events;
        const { name, requestId, formatDefinition, medium } = this.adSlot || {};
        if (formatDefinition?.reportRequest) {
            reporter.request(this.adSlot);
            mediaEvents.event(Type.audioVideoAd, Status.requested).emit({
                adRequestId: requestId,
                adNetworkName: get(formatDefinition, 'adProvider'),
                adType: getState(State.adTypeRequested) || medium,
                slotName: name,
                adUnitId: get(formatDefinition, 'adUnitId'),
                ...(formatDefinition.medium === VIDEO_MEDIUM && {
                    adRequestHasAmazonKeywords: !!getState(State.videoApsCustParams),
                }),
            });
        }
        else {
            logger.error({
                message: IMA_PLAYER_AD_REQUEST_REPORTING_ERROR,
                data: {
                    ...reporter.getParameters(this.adSlot),
                    reportRequest: !!formatDefinition?.reportRequest,
                },
            });
        }
        logger.debug('Ad Requested.');
    },
    _onAdLoaded(ad) {
        const { adId, creativeId } = pick(ad, [
            'height',
            'width',
            'adId',
            'creativeId',
            'isVideoAd',
        ]);
        updateState(State.audioVideoAdId, adId);
        updateState(State.audioVideoAdCreativeId, creativeId);
        const { Type, Status } = Events;
        const { name, requestId, formatDefinition } = this.adSlot || {};
        mediaEvents.event(Type.audioVideoAd, Status.loaded).emit({
            slotName: name,
            adRequestId: requestId,
            adNetworkName: get(formatDefinition, 'adProvider'),
            ...ad,
        });
        logger.debug('Ad Loaded.');
    },
    _onAdStarted(adInfo) {
        const { formatDefinition, name: adSlotName, requestId } = this.adSlot || {};
        const { adProvider, adUnitId } = formatDefinition || {};
        mediaEvents.event(Events.Type.audioVideoAd, Events.Status.playing).emit({
            ...adInfo,
            adUnitId,
            adNetworkName: adProvider,
            adRequestId: requestId,
            slotName: adSlotName,
        });
        reporter.start(this.adSlot);
        logger.debug('Ad Started.');
    },
    _onAdSkipped(data) {
        mediaEvents
            .event(Events.Type.audioVideoAd, Events.Status.skipped)
            .emit(data);
        reporter.skip(this.adSlot);
        logger.debug('Ad Skipped.');
    },
    _onAdImpression() {
        reporter.impression(this.adSlot);
        logger.debug('Ad Impression.');
    },
    _onAdCompleted(adInfo) {
        const { formatDefinition, name: adSlotName, requestId } = this.adSlot || {};
        const { adProvider, adUnitId } = formatDefinition || {};
        mediaEvents.event(Events.Type.audioVideoAd, Events.Status.ended).emit({
            ...adInfo,
            adUnitId,
            adNetworkName: adProvider,
            adRequestId: requestId,
            slotName: adSlotName,
        });
    },
    _onAllAdsCompleted(ad) {
        const { formatDefinition } = this.adSlot;
        mediaEvents.event(Events.Type.audioVideoAd, Events.Status.allEnded).emit({
            slotName: this.adSlot.name,
            adsCount: ad.totalAdsInPod,
            adRequestId: this.adSlot.requestId,
            adNetworkName: get(formatDefinition, 'adProvider'),
        });
        reporter.end(this.adSlot);
        logger.debug('All Ads Completed.');
    },
    _onAdCompanionLoadError(error) {
        logger.error({
            message: IMA_PLAYER_AD_COMPANION_ERROR,
            error,
            data: reporter.getParameters(this.adSlot),
        });
    },
    _onAdError(errorData = {}) {
        let errorMessage;
        let errorCode;
        let reportMessage;
        let isNoFill = false;
        const { formatDefinition, name: adSlotName, requestId } = this.adSlot || {};
        const { adProvider, adUnitId } = formatDefinition || {};
        const { error, errorType, adInfo } = errorData;
        const adTypeRequested = getState(State.adTypeRequested);
        const { Type, Status } = Events;
        try {
            errorMessage = error.getMessage();
            errorCode = error.getErrorCode();
            isNoFill = errorCode === 1009 || errorCode === 303;
            reportMessage = isNoFill
                ? NO_FILL_LABEL
                : `errorCode:${errorCode}|errorMessage:${errorMessage}`;
        }
        catch (e) {
            reportMessage = error;
        }
        reporter.fail(this.adSlot, reportMessage);
        logger.debug('Ad Error.', reportMessage);
        logger.error({
            message: IMA_PLAYER_AD_ERROR,
            error: reportMessage,
            data: reporter.getParameters(this.adSlot),
        });
        mediaEvents.event(Type.audioVideoAd, Status.error).emit({
            errorType: isNoFill ? Events.ErrorTypes.AD_NO_FILL : errorType,
            errorCode,
            errorMessage,
            adInfo: {
                ...adInfo,
                adUnitId,
                adType: adTypeRequested,
                adSlot: adSlotName,
                adNetworkName: adProvider,
                adRequestId: requestId,
                slotName: adSlotName,
                isVideoAd: adTypeRequested === VIDEO_MEDIUM,
            },
        });
    },
    _onAutoPlayError(error) {
        logger.error({
            message: IMA_PLAYER_AUTOPLAY_ERROR,
            error,
            data: reporter.getParameters(this.adSlot),
        });
    },
    _onVideoAdLoaded(ad) {
        this.isPlayingVideo = true;
        this.adSlot.medium = MediumTypes.video;
        const volume = getState(State.volume);
        this.volume(volume);
        const clickThroughUrl = get(ad, 'clickThroughUrl');
        const { Type, Media, Status } = Events;
        mediaEvents.event(Type.audioVideoAd, Media.video, Status.loaded).emit();
        mediaEvents
            .event(Type.audioVideoAd, Media.video, Status.setLearnMore)
            .emit(clickThroughUrl);
        logger.debug('Video Ad Loaded.');
    },
    _onVideoAdStarted() {
        updateState(State.isPlayingVideoAd, true);
        const { Type, Media, Status } = Events;
        mediaEvents.event(Type.audioVideoAd, Media.video, Status.started).emit();
        forEach(adSlotManager.getDisplaySlots(), (slot) => slot.refresh());
        logger.debug('Video Ad Started.');
    },
    _onVideoAdSkipped(adInfo) {
        const { formatDefinition, name: adSlotName, requestId } = this.adSlot || {};
        const { adProvider, adUnitId } = formatDefinition || {};
        updateState(State.isPlayingVideoAd, false);
        mediaEvents
            .event(Events.Type.audioVideoAd, Events.Media.video, Events.Status.skipped)
            .emit({
            ...adInfo,
            adUnitId,
            adNetworkName: adProvider,
            adRequestId: requestId,
            slotName: adSlotName,
        });
        logger.debug('Video Ad Skipped.');
    },
    _onVideoAdImpression() {
        updateState(State.videoAdPlayed, true);
        logger.debug('Video Ad Impression.');
    },
    _onVideoAdPaused() {
        mediaEvents.event(Events.Type.audioVideoAd, Events.Status.paused).emit();
        logger.debug('Video Ad Paused.');
    },
    _onVideoAdProgress(event) {
        const { Type, Status } = Events;
        mediaEvents.event(Type.audioVideoAd, Status.progress).emit(event);
        logger.debug('Video Ad Progress.');
    },
    _onVideoAdResumed() {
        mediaEvents.event(Events.Type.audioVideoAd, Events.Status.playing).emit();
        logger.debug('Video Ad Resumed.');
    },
    _onVideoAdCompleted() {
        updateState(State.isPlayingVideoAd, false);
        mediaEvents
            .event(Events.Type.audioVideoAd, Events.Media.video, Events.Status.ended)
            .emit();
        logger.debug('Video Ad Completed.');
    },
    _onAudioLoaded() {
        this.isPlayingVideo = false;
        this.adSlot.medium = MediumTypes.audio;
        logger.debug('Audio Ad Loaded.');
    },
    _onAudioAdStarted() {
        logger.debug('Audio Ad Started.');
    },
    _onAudioAdSkipped() {
        mediaEvents
            .event(Events.Type.audioVideoAd, Events.Media.audio, Events.Status.skipped)
            .emit();
        logger.debug('Audio Ad Skipped.');
    },
    _onAudioAdPaused() {
        mediaEvents.event(Events.Type.audioVideoAd, Events.Status.paused).emit();
        logger.debug('Audio Ad Paused.');
    },
    _onAudioAdProgress(event) {
        const { Type, Status } = Events;
        mediaEvents.event(Type.audioVideoAd, Status.progress).emit(event);
        logger.debug('Audio Ad Progress.');
    },
    _onAudioAdResumed() {
        mediaEvents.event(Events.Type.audioVideoAd, Events.Status.playing).emit();
        logger.debug('Audio Ad Resumed.');
    },
    _onAudioAdCompleted() {
        logger.debug('Audio Ad Completed.');
    },
    _onAudioCompanionsLoaded(companions) {
        try {
            const displaySlots = adSlotManager.getDisplaySlots();
            const adProvider = get(this.adSlot, 'formatDefinition.adProvider');
            if (!adProvider) {
                return;
            }
            logger.debug('Audio Ad Companions Loaded.');
            this.companionAdManager.processCompanionAds(companions, displaySlots, adProvider);
        }
        catch (ex) {
            logger.error({
                message: IMA_PLAYER_AD_COMPANION_ERROR,
                error: ex,
                data: reporter.getParameters(this.adSlot),
            });
        }
    },
    _onCompanionSlotRefresh(slotId) {
        const displaySlot = adSlotManager.getSlot(slotId);
        if (displaySlot) {
            displaySlot.refresh();
        }
    },
    _onAudioCompanion(companionSlot) {
        try {
            const { elementId, name, format, width, height, content } = companionSlot;
            if (!(elementId && name && format && width && height && content)) {
                return;
            }
            const mintSlot = adSlotManager.getSlot(elementId);
            if (!mintSlot) {
                return;
            }
            if (mintSlot.adTypeController) {
                mintSlot.adTypeController.deregisterSlot(mintSlot);
                mintSlot.adTypeController.releaseSlot(mintSlot);
            }
            mintSlot.formatDefinition = format;
            mintSlot.currentDimensions = [width, height];
            logger.info({
                message: 'on.audio.companion.debug.dimensions.issue',
                data: {
                    currentDimensions: [width, height],
                },
            });
            mintSlot.requestId = this.adSlot.requestId;
            const slotElement = global.document.getElementById(elementId);
            if (!slotElement) {
                return;
            }
            this.companionAdManager.renderCompanionAd(slotElement, mintSlot, width, height, content);
            adSlotManager.addCompanionSlot(mintSlot);
            reporter.impression(mintSlot);
            logger.debug('Audio Ad Companion Rendered/Impression.');
        }
        catch (ex) {
            const { elementId } = companionSlot;
            const mintSlot = adSlotManager.getSlot(elementId);
            mediaEvents.event(Events.Media.display, Events.Status.failed).emit({
                slot: mintSlot,
                errorCode: '',
                errorMessage: '',
                debugDescription: 'Display Ad, Companion Ad via _onAudioCompanion',
            });
            logger.error({
                message: IMA_PLAYER_AD_COMPANION_ERROR,
                error: ex,
                data: reporter.getParameters(this.adSlot),
            });
        }
    },
    _onCompanionAdClick(slot) {
        if (!slot) {
            return;
        }
        mediaEvents.event(Events.Media.display, Events.Status.click).emit({
            slot,
            isCompanionAd: true,
        });
        reporter.click(slot);
        logger.info({
            message: COMPANION_AD_CLICKED,
            data: reporter.getParameters(slot),
        });
    },
    _onInvalidCompanionClickHandler(slot) {
        if (!slot) {
            return;
        }
        logger.error({
            message: COMPANION_INVALID_CLICK_HANDLER,
            data: reporter.getParameters(slot),
        });
    },
    _onCompanionAdRenderError(event) {
        const { slot, error } = pick(event, ['slot', 'error']);
        if (!(slot && error)) {
            return;
        }
        logger.error({
            message: COMPANION_AD_RENDER_ERROR,
            error,
            data: reporter.getParameters(slot),
        });
    },
};
export default imaPlayerAdapter;
